import { useMixpanel } from '@/hooks/use-mixpanel';
import {
  Flex,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useLocation } from 'react-router-dom';
import { SearchMd } from '@kula-ai/icons-core';
import { KText } from 'ui-library/components';
import { GlobalSearch } from '@/components/global-search';
import { GlobalSearchV1 } from './GlobalSearchV1';
import { useKFlags } from '@/hooks/use-k-flags';

export const TopNavSearchBar = () => {
  const [isSearchOpen, setSearchOpen] = useState<boolean>(false);
  const { pathname } = useLocation();
  const { track } = useMixpanel();
  const { feAiSearch } = useKFlags();

  //To close the universal search modal when path changes
  useEffect(() => {
    setTimeout(() => {
      setSearchOpen(false);
    }, 0);
  }, [pathname]);

  useHotkeys(
    'mod+k',
    () => {
      track({
        event: 'global-search',
        prop: {
          type: 'shortcut',
        },
      });
      setSearchOpen((prev) => !prev);
    },
    { enableOnFormTags: ['INPUT', 'SELECT', 'TEXTAREA'] }
  );

  return (
    <>
      <Flex maxH="39px" w="100%" alignItems="center" justifyContent="center">
        <InputGroup
          bgColor="rgba(255, 255, 255, 0.2)"
          borderRadius="sm"
          w="524px"
          alignItems="center"
        >
          <InputLeftElement pointerEvents="none">
            <SearchMd
              size="1em"
              color="rgba(255, 255, 255, 0.6)"
              className="kula-icon"
            />
          </InputLeftElement>
          <KText
            padding="10px 2.5em"
            outlineOffset="2px"
            size="sm"
            cursor="pointer"
            minH="2.5em"
            w="100%"
            color="rgba(255, 255, 255, 0.6)"
            onClick={() => {
              setSearchOpen(true);
            }}
          >
            Search
          </KText>
          <InputRightElement>
            <KText color={'rgba(255, 255, 255, 0.6)'}>⌘ K</KText>
          </InputRightElement>
        </InputGroup>
      </Flex>
      {isSearchOpen &&
        (feAiSearch ? (
          <GlobalSearchV1 onClose={() => setSearchOpen(false)} />
        ) : (
          <GlobalSearch
            isOpen={isSearchOpen}
            onClose={() => setSearchOpen(false)}
          />
        ))}
    </>
  );
};
